<template>  
  <modal v-model="show"
        :has-padding="false"
        @input="hideModal"
        content-class="marketing-create-type-modal"
         max-width="500" >    

    <div class="marketing-create-type-modal-body">
      <app-form @submit="goToNextStep">
        <template v-if="!duplicate">
          <h1 class="marketing-create-type-modal-body-title">{{ titleText }}</h1>

          <text-field v-model="title"
                      class="marketing-create-type-modal-body-input"
                      :label="inputAttributes.label"
                      :name="inputAttributes.name"
                      :help="inputAttributes.help"
                      validate="required" />

        </template>

        <div class="marketing-create-type-modal-body-select">
          <p class="marketing-create-type-modal-body-select-label">{{ radioText.text }}</p>

          <validation-provider v-slot="{ errors }"
                               :name="radioText.radio.name"
                               tag="div"
                               class="marketing-create-type-modal-body-select-radios"
                               rules="required">

            <v-radio-group v-model="isAutomationFlow"
                           :error-messages="errors">

              <div class="marketing-create-type-modal-body-select-radios-item">
                <v-radio :value="false"></v-radio>

                <div class="marketing-create-type-modal-body-select-radios-item-texts">
                  <div class="marketing-create-type-modal-body-select-radios-item-texts-label">{{$t('message.marketingGenerics.message.singleSend')}}</div>
                  <div class="marketing-create-type-modal-body-select-radios-item-texts-info">{{ radioText.radio.single.info }}</div>
                </div>

              </div>

              <div class="marketing-create-type-modal-body-select-radios-item">
                <v-radio :value="true"></v-radio>

                <div class="marketing-create-type-modal-body-select-radios-item-texts">
                  <div class="marketing-create-type-modal-body-select-radios-item-texts-label">{{$t('message.marketingGenerics.message.automation')}}</div>
                  <div class="marketing-create-type-modal-body-select-radios-item-texts-info">{{ radioText.radio.automation.info }}</div>
                </div>

              </div>

            </v-radio-group>

          </validation-provider>

        </div>

        <button class="marketing-create-type-modal-body-action btn btn-extra-round btn-primary "
                type="submit">
          {{ duplicate ? this.$t('message.generics.message.duplicate') :  this.$t('message.marketingGenerics.message.nextStep') }}
        </button>
      </app-form>
    </div>
  </modal>  
</template>

<script>
import { ValidationProvider } from "vee-validate";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@/components/generic/Modal";


export default {
  components: {
    TextField,
    ValidationProvider,
    AppForm,
    Modal
  },

  data() {
    return {
      isAutomationFlow: undefined,
      title: undefined,
      show: false
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    duplicate: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: false,
    },
    email: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    titleText() {
      return this.email ? this.$t('message.email.message.newEmail') : this.$t('message.sms.message.newSms');
    },
    inputAttributes() {
      return {
        label: this.email ? this.$t('message.email.message.emailName') : this.$t('message.sms.message.smsName'),
        name: this.email ? this.$t('message.email.message.emailName') : this.$t('message.sms.message.smsName'),
        help: this.email
          ? this.$t('message.email.message.tooltipEmailName')
          : this.$t('message.sms.message.tooltipSmsName'),
      };
    },
    radioText() {
      return {
        title: this.email ? this.$t('message.email.message.emailPurpose') : this.$t('message.sms.message.smsPurpose'),
        radio: {
          name: this.email ? this.$t('message.email.message.emailPurpose') : this.$t('message.sms.message.smsPurpose'),
          single: {
            info: this.email
              ? this.$t('message.email.message.emailSingleSendInfo')
              : this.$t('message.sms.message.smsSingleSendInfo'),
          },
          automation: {
            info: this.email
              ? this.$t('message.email.message.emailAutomationInfo')
              : this.$t('message.sms.message.smsAutomationInfo'),
          },
        },
      };
    },
    
  },

  watch: {
    value(val) {
      val ? this.show = true : this.show = false
    }
    // value(opened) {
    //   if (opened) {
    //     this.resetData();
    //     let drag = false;
    //       document.addEventListener(
    //           'mousedown', () => drag = false);
      
    //       document.addEventListener(
    //           'mousemove', () => drag = true);
            
    //       document.addEventListener(
    //           'mouseup', (event) =>  {
    //             console.log(drag ? 'drag' : 'click')
    //             console.log("event", event)
    //             if(event.target.className == "v-overlay v-overlay--active" && !drag) {
    //               console.log('clicou fora e fecha modal')
    //               this.hideModal()
    //             }
    //           }
    //               );
    //   }
    // },
  },

  methods: {
    resetData() {
      this.isAutomationFlow = undefined;
      this.title = undefined;
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.emitInput(false);
    },
    async goToNextStep() {
      if (this.duplicate) {
        this.$emit("duplicate", {
          isAutomationFlow: this.isAutomationFlow,
        });
      } else {
        this.$emit("nextStep", {
          isAutomationFlow: this.isAutomationFlow,
          title: this.title,
        });
        this.saveEmailDataInSessionStorage()
      }
    },
    saveEmailDataInSessionStorage() {
      const emailForm = {
        isAutomationFlow: this.isAutomationFlow,
        title: this.title
      }
      sessionStorage.setItem("email_data", JSON.stringify(emailForm))
    }
  },
};
</script>

<style lang="scss" scoped>

.marketing-create-type-modal {
  .marketing-create-type-modal-body {
    padding: 20px 40px;

    .marketing-create-type-modal-body-title {
      text-align: center; 
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .marketing-create-type-modal-body-input {
      margin-bottom: 20px !important;
    }

    .marketing-create-type-modal-body-select {
      margin-bottom: 20px;

      .marketing-create-type-modal-body-select-label {
        color: #707070;
        text-align: center;
        font-weight: 600;
        margin-bottom: 40px;
      }

      .marketing-create-type-modal-body-select-radios {
        .marketing-create-type-modal-body-select-radios-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 20px;

          .marketing-create-type-modal-body-select-radios-item-texts-label {
            color: #3b3b3b;
            margin-bottom: 5px;
            font-weight: 600;
          }

          .marketing-create-type-modal-body-select-radios-item-texts-info {
            color: #707070;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        &.marketing-create-type-modal-body-select-radios_error {
          .marketing-create-type-modal-body-select-radios-item {
            .marketing-create-type-modal-body-select-radios-item-texts-label {
              color: #ff4141;
            }
          }
        }
      }
    }

    .marketing-create-type-modal-body-action {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
